import React, { Component } from "react";
import withStyles from "@mui/styles/withStyles";
import styles from "../ClientDashboard/styles/formDialogStyles";
import { Typography, Button } from "@mui/material";
import Logo from "../../assets/answers_now_logo_dark_purple.png";
import LogoMobile from "../../assets/an_purple_butterfly_logo.png";
import _ from "lodash";
import Modal from "elements/Modal";
import PandaDocContainer from "components/PandaDocContainer";

class TreatmentPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmOpen: false,
      completed: false,
    };
  }

  setFormComplete = () => {
    this.setState({ completed: true });
  };

  onToggleConfirmTreatmentPlan = () => {
    this.setState({ confirmOpen: !this.state.confirmOpen });
  };

  render() {
    const {
      open,
      onToggleTreatmentPlan,
      classes,
      onSubmitTreatmentPlanApproval,
    } = this.props;
    const sessionId = this.props?.treatmentPlan?.panda_doc_session_id;
    const documentId = this.props?.treatmentPlan?.panda_doc_document_id;
    return (
      <>
        {sessionId && documentId && open && (
          <Modal
            open={open}
            title="Review Your Treatment Plan"
            content={
              <div className={classes.formContainer}>
                <div className={classes.innerFormContainer}>
                  <div className={classes.form}>
                    <div className={classes.logoContainer}>
                      <img className={classes.logo} src={Logo} alt="AnswersNow" title="AnswersNow" />
                      <img
                        className={classes.logoMobile}
                        src={LogoMobile}
                        alt="AnswersNow"
                        title="AnswersNow"
                      />
                    </div>
                    <div className={classes.pandaDocContainer}>
                      <PandaDocContainer
                        pandaDocSessionId={sessionId}
                        onDocumentCompleted={this.setFormComplete}
                        pandaDocId={documentId}
                      />
                    </div>
                    <div className={classes.buttonContainer}>
                      <div className={classes.divider} />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={onSubmitTreatmentPlanApproval}
                        disabled={!this.state.completed}
                        fullWidth
                        size="large"
                      >
                        Submit
                      </Button>
                      <Button
                        color="primary"
                        variant="text"
                        onClick={onToggleTreatmentPlan}
                        fullWidth
                      >
                        Cancel
                      </Button>
                    </div>
                    <Typography component="p" variant="body2" textAlign="center">
                      Have questions? Reach us directly at{" "}
                      <span style={{ color: "#8E42CA" }}>804-215-5600</span>
                    </Typography>
                  </div>
                </div>
              </div>
            }
          />
        )}
      </>
    );
  }
}

export default withStyles(styles)(TreatmentPlan);